export const LoginStatus = {
    Pending: 'pending',
    Success: 'success',
};
